<script setup>
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import Trans from '@/i18n/translation';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';
import { useGlobalState } from '@/store/user.store';
import WithLoader from '@/components/WithLoader.vue';

const router = useRouter();
const { callEndpoint, isLoading } = useCallEndPointWith('logout');
const { resetUserState } = useGlobalState();

onMounted(async () => {
  await callEndpoint({ method: 'POST', request: {} });
  resetUserState();
  await router.push(Trans.i18nRoute({ name: 'home' }));
});

</script>
<template>
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        {{ $t('logoutView.header') }}
      </h1>
      <WithLoader :is-loading="isLoading" />
    </div>
  </main>
</template>
